<template>
  <component :is="readOnly ? 'froalaView' : 'froala'"
             :class="{'border p-2 bg-gray-150':readOnly}"
             :config="froalaConfig"
             v-model="valueFromProp"></component>
</template>

<script>
  export default {
    name: 'gtc-froala',
    props: {
      readOnly: {
        type: Boolean,
        default: false
      },
      value: {
        default: null
      }
    },
    computed: {

    },
    created() {
      this.loadFroalaConfig();
      this.valueFromProp = _.trim(this.value);
      if (this.readOnly && this.valueFromProp === '') this.valueFromProp = 'N/A';
    },
    data: function () {
      return {
        froalaConfig: null,
        valueFromProp: null
      }
    },
    watch: {
      valueFromProp(newVal, oldVal) {
        let self = this;
        if (!this.readOnly && JSON.stringify(newVal) !== JSON.stringify(oldVal))
          self.$emit('input', newVal);
      },
      value(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
          this.valueFromProp = newVal;
      }
    },
    methods: {
      loadFroalaConfig() {
        let self = this;
        self.froalaConfig = {
          key: 'SB3B17A7B8jC5D4H4G4J2A7A8C4A4A2A-9efpdeA6kfg==',
          attribution: false,
          // reference: https://froala.com/wysiwyg-editor/examples/toolbar-buttons-2/
          events: {
            initialized: function () {

            }
          },
          fileUpload: false,
          imageUpload: true,
          imageUploadURL: self.$root.baseUrl + '/nre/upload_image/',
          imageUploadMethod: 'POST',
          toolbarButtons: [
            'bold', 'italic', 'underline', 'strikeThrough', 'fontSize', 'color', '|',
            'formatOL', 'formatUL', '|', 'spellChecker'],
          pluginsEnabled: [
            'align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable',
            'embedly', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image',
            'imageManager', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat',
            'paragraphStyle', 'quote', 'save', 'table', 'url', 'video', 'wordPaste', 'print'
          ],
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcFroala.vue